import {getQuery} from "@/modules/common/utils";

const getTags = async () => {
  let res;

  try {
    res = await getQuery('tags', {names_only: true});
    res = {tags: res.data};
  }
  catch (error) {
    res = {error: error.errors.message};
  }

  return res;
};

export default {
  getTags
}
